import CustomZObject from './CustomZObject.js';

export default class ZToggle extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.value = 0;

        this.newInlet("input", ([msg]) => this.onInput(msg));
        this.newOutlet("output");
    }

    onInput(msg) {
        if (msg === "start") {
            this.sendMessage("output", this.value);
            return;
        }
        if (msg === "bang") {
            this.toggle();
        } else {
            if (msg === 0 || msg === 1) {
                this.value = msg;
                this.sendMessage("output", this.value);
            }
        }
    }

    toggle() {
        this.value = this.value === 0 ? 1 : 0;
        this.sendMessage("output", this.value);
        return this.value;
    }

    getJson(isPreset) {
        return {
            ... super.getJson(isPreset),
            value: this.value,
            needsLoad: true
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        this.value = json.value;
        if (json.needsLoad) {
            this.zObject.needsLoad = true;
            console.log("TOGGLE NEEDS LOAD = ", true);
        }  else {
            this.zObject.needsLoad = false;
            console.log("TOGGLE NEEDS LOAD = ", false);
        }
    }
}
